import React, { useState, useEffect } from 'react';

function WhereToBuy() {

    const getLang = localStorage.getItem('lang_code');
    const [mitraList, SetMitraList] = useState([]);
    const urlImg = "https://dev.jftheskinspecialist.com/images/pages/";

    useEffect(() => {
        fetch('https://dev.jftheskinspecialist.com/api/mitra')
            .then((res) => {
                return res.json();
            })
            .then((datas) => {
                SetMitraList(datas.data);
            });
    }, []);

    return (
        <div class="max-w-screen-lg mx-auto p-6">
            <div class="flex justify-between items-center">
                <h3 class="font-bold text-2xl inline-block border-b-4 border-[#ff8e35] pb-2" style={{ color: '#fd9400', fontFamily: 'MuseoSansRounded900', fontWeight: 'bold' }}>
                    {getLang === 'id' ? 'Dapat di beli di sini' : 'Can Buy Here'}
                </h3>
            </div>

            <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-6">
                {/*<div class="bg-white p-6 flex items-center justify-center border-slate-300 border-2 rounded-lg">
                    <img src="https://dev.galenium.com/assets/media/images/business_mitra_1.png" alt="Alfamart" class="max-h-32" />
                </div>
                <div class="bg-white p-6 flex items-center justify-center border-slate-300 border-2 rounded-lg">
                    <img src="https://dev.galenium.com/assets/media/images/business_mitra_2.png" alt="Alfamidi" class="max-h-32" />
                </div>
                <div class="bg-white p-6 flex items-center justify-center border-slate-300 border-2 rounded-lg">
                    <img src="https://dev.galenium.com/assets/media/images/business_mitra_3.png" alt="Indomaret" class="max-h-32" />
                </div>
                <div class="bg-white p-6 flex items-center justify-center border-slate-300 border-2 rounded-lg">
                    <img src="https://dev.galenium.com/assets/media/images/business_mitra_4.png" alt="Watsons" class="max-h-32" />
                </div>
                <div class="bg-white p-6 flex items-center justify-center border-slate-300 border-2 rounded-lg">
                    <img src="https://dev.galenium.com/assets/media/images/business_mitra_5.png" alt="Century Healthcare" class="max-h-32" />
                </div>
                <div class="bg-white p-6 flex items-center justify-center border-slate-300 border-2 rounded-lg">
                    <img src="https://dev.galenium.com/assets/media/images/business_mitra_6.png" alt="K24" class="max-h-32" />
                </div>
                <div class="bg-white p-6 flex items-center justify-center border-slate-300 border-2 rounded-lg">
                    <img src={Lgftgstore} alt="G-Store" class="max-h-32" />
                </div>
                <div class="bg-white p-6 flex items-center justify-center border-slate-300 border-2 rounded-lg">
                    <img src={Lgshoppe} alt="G-Store" class="max-h-32" />
                </div>
                <div class="bg-white p-6 flex items-center justify-center border-slate-300 border-2 rounded-lg">
                    <img src={Lgtokped} alt="G-Store" class="max-h-32" />
                </div>*/}
                {mitraList.map((item, index) => (
                    <a href={item.created_by_alias} target="_blank" rel="noreferrer">
                        <div key={index} class="bg-white p-6 flex items-center justify-center border-slate-300 border-2 rounded-lg h-[120px]">
                            <img src={urlImg + '' + item.featured_image} alt={item.name} class="max-h-32" />
                        </div>
                    </a>
                ))}
            </div>
            <br />
        </div>
    );
}

export default WhereToBuy;
